import React from 'react'
import { connect } from 'react-redux'
import { MobileHamburgerMenu } from '../utils'

const NavigationMenu = () => <MobileHamburgerMenu />

export default connect((state) => ({
  isPhone: state.device.isPhone,
}))(NavigationMenu)
